<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button v-if="!isBlocked" type="submit" :disabled="loading" class="btn btn-icon btn-success mar-rt-10 save save-draft" style="margin-bottom: 0;" @click.prevent="validate" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('gestiune.saveDraft')}}
            </button>
            <button v-if="state === 'VALIDATED' && isBlocked" type="submit" :disabled="loading" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click.prevent="saveInventar(true)" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('gestiune.revalidated')}}
            </button>
            <button v-if="isInEdit && !isBlocked" type="submit" :disabled="loading" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveInventar(true)" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('gestiune.saveAndValidate')}}
            </button>
            <button
              v-if="state !== 'VALIDATED'"
              type="button"
              :disabled="loading"
              class="btn btn-icon btn-warning mar-rt-10"
              style="margin-bottom: 0;"
              @click.prevent="updateStockScriptic"
              :title="$t('gestiune.updateStockScriptic')"
            >
              {{$t('gestiune.updateStockScriptic')}}
            </button>
            <button
              v-if="state !== 'VALIDATED'"
              type="button"
              :disabled="loading"
              class="btn btn-icon btn-xls-slim"
              style="margin-bottom: 0;"
              @click.prevent="onPrintInventory"
              :title="$t('gestiune.printInventorySheet')"
            >
              <img src="/static/img/export_xls.png">
              {{$t('gestiune.printInventorySheet')}}
            </button>
        </p>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div class="modal-header">
          <p>{{ $t('gestiune.inventar') }}</p>
        </div>
        <div v-if="state === 'DRAFT'" class="alert alert-warning note-draft">
          <strong>ℹ️ Notă informativă:</strong><br>
          Acest inventar este în status <b>DRAFT</b>.
          Mișcările de stoc <b>nu vor apărea</b> în rapoarte cât timp inventarul este în acest status.
          Folosește butonul <b>„Salvează și validează”</b> pentru a trece inventarul în status <b>VALIDAT</b>, moment în care mișcările de stoc vor fi incluse în raport.
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group" v-if="groupedLocations">
                <label>{{ $t('gestiune.locatie') }}</label>
                <select class="form-control" v-model="selectedLocation" v-validate="modelValidate.location" :disabled="loading || isInEdit">
                  <option :value="null" disabled>Selectează locația</option>
                  <optgroup
                    v-for="group in groupedLocations"
                    :key="group.vat"
                    :label="`VAT: ${group.vat}`"
                  >
                    <option
                      v-for="loc in group.locations"
                      :key="loc.id"
                      :value="loc"
                    >
                      {{ loc.name }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ $t('gestiune.gestiune') }}</label>
                <el-select
                    v-model="selectedGestiune"
                    placeholder="Selectează gestiunea"
                    :disabled="loading || isInEdit"
                    v-validate="modelValidate.gestiune"
                  >
                  <el-option
                    v-for="gestiune in filteredGestiuni"
                    :key="gestiune.id"
                    :label="gestiune.name"
                    :value="gestiune.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="inventoryNumber">{{ $t('invoice.seriesNumber') }}</label>
                <el-select v-model="inventoryNumber" :options="inventoryNumberOptions" :disabled="isInEdit" v-validate="modelValidate.serie" @change="handleSerieChange">
                  <el-option v-for="item in seriesOptionsWithAdd" :key="item._id" :label="item.label" :value="item._id" />
                </el-select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ $t('gestiune.date') }}</label>
                <input type="datetime-local" :disabled="isBlocked" :max="today" v-validate="modelValidate.date" class="form-control" v-model="inventoryDate" />
              </div>
              <!-- <div class="form-group">
                <label for="inventoryDate">{{ $t('gestiune.date') }}</label>
                <el-date-picker v-model="inventoryDate" :disabled="isBlocked" type="date" placeholder="Selectați data" v-validate="modelValidate.date"></el-date-picker>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div class="row">
          <div class="col-md-4">
            <label>Filtreaza produsele dupa categorie:</label>
            <select v-model="selectedCategory" @change="filterProducts" class="form-control">
              <option :value="null">-- Toate categoriile --</option>
              <option v-for="cat in categories" :key="cat" :value="cat">
                {{ cat }}
              </option>
            </select>
          </div>
        </div>
        <br>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('invoice.productName') }}</th>
              <th>{{ $t('gestiune.type') }}</th>
              <th>{{ $t('invoice.unitMeasure') }}</th>
              <th>{{ $t('gestiune.stocScriptic') }}</th>
              <th>{{ $t('gestiune.stocFaptic') }}</th>
              <th>{{ $t('gestiune.difference') }}</th>
              <!-- <th>{{ $t('general.actions') }}</th> -->
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in productsList" >
              <template v-if="item.is_hiden !== 1">
                <tr :key="index" :class="{ 'row-updated': item._updated }">
                  <td>{{ item.productDetails.name }}</td>
                  <td>{{ item.productDetails.categorie }}</td>
                  <td>{{ item.productDetails.um }}</td>
                  <td>{{ item.quantity.toFixed(2) }}</td>
                  <td>
                    <input type="number" :disabled="isBlocked" class="form-control" min="0" v-model="item.stocFaptic">
                  </td>
                  <td>{{ ((item.quantity - (item.stocFaptic != null ? item.stocFaptic : item.quantity)) * -1).toFixed(2) }}</td>
                  <!-- <td>
                     <a class="btn btn-danger btn-icon delete mar-rt-10" @click="removeItem(index)">
                        <img src="/static/img/icons/icon-close.png">
                        {{$t('general.delete')}}
                    </a>
                  </td> -->
                </tr>
              </template>
            </template>
            <tr v-if="loading"><td>
              <div class="loadingTableCenter">
                <div :class="(loading ? 'show-loader' : 'hide-loader')">
                  <div class="el-loading-spinner">
                    <svg viewBox="25 25 50 50" class="circular">
                      <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                    </svg>
                  </div>
                </div>
              </div>
            </td></tr>
            <tr v-if="!isBlocked">
              <td>
                <v-select
                  v-model="searchProdName"
                  :options="searchResults"
                  label="label"
                  placeholder="Caută un produs..."
                  :filterable="true"
                  @input="onProductSelect"
                ></v-select>
              </td>
              <td>
                <input type="text" class="form-control" :disabled="true" v-model.number="newItem.unitMeasure" placeholder="UM" />
              </td>
              <td>
                <input type="number" class="form-control" :disabled="true" v-model.number="newItem.quantity" placeholder="Stoc scriptic" />
              </td>
              <td>
                <input type="number" class="form-control" v-model.number="newItem.stocFaptic" placeholder="Stoc faptic" />
              </td>
              <td>
                <button class="btn btn-primary" @click="addItem">{{ $t('general.add') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <h5>Comisia de Inventariere</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="presedinteleComisiei">Președintele Comisiei</label>
              <input type="text" id="presedinteleComisiei" v-model="extraFields.presedinte" :disabled="isBlocked" class="form-control" placeholder="Numele președintelui comisiei" />
            </div>
            <div class="form-group">
              <label for="gestionar">Gestionar</label>
              <input type="text" id="gestionar" v-model="extraFields.gestionar" :disabled="isBlocked" class="form-control" placeholder="Numele gestionarului" />
            </div>
            <div class="form-group">
              <label for="notaInternaComisie">Notă internă</label>
              <textarea id="notaInternaComisie" v-model="extraFields.nota" :disabled="isBlocked" class="form-control" placeholder="Informații suplimentare"></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="comisiaDeInventariere">Comisia de Inventariere</label>
              <input type="text" id="comisiaDeInventariere" v-model="extraFields.comisia" :disabled="isBlocked" class="form-control" placeholder="Denumirea comisiei" />
            </div>
            <div class="form-group">
              <label for="contabilitate">Contabilitate</label>
              <input type="text" id="contabilitate" v-model="extraFields.contabilitate" :disabled="isBlocked" class="form-control" placeholder="Detalii contabilitate" />
            </div>
            <div class="form-group">
              <label for="notaInternaCompletare">Notă internă (completare)</label>
              <textarea id="notaInternaCompletare" v-model="extraFields.nota_completare" :disabled="isBlocked" class="form-control" placeholder="Detalii suplimentare notă internă"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ManagementSeriesAdd
      :locations="locations"
      :grouped-locations="groupedLocations"
      :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
      @getSeries="getSeries"
    />
  </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
// import {mapFields} from 'vee-validate'
import swal from 'sweetalert2'
export default {
  components: {
    // GeneralTopBar,
    ManagementSeriesAdd
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      gestiune: '',
      inventoryNumber: '',
      inventoryDate: this.getLocalDateTimeString(),
      selectedLocation: null,
      selectedGestiune: null,
      searchProdName: null,
      extraFields: {
        'presedinte': '',
        'comisia': '',
        'gestionar': '',
        'contabilitate': '',
        'nota': '',
        'nota_completare': ''
      },
      newItem: {
        name: '',
        quantity: '',
        unitMeasure: '',
        stocFaptic: null
      },
      modelValidate: {
        location: 'required',
        gestiune: 'required',
        serie: 'required',
        date: 'required'
      },
      categories: [
        'Marfa',
        'Materii prime',
        'Materiale consumabile',
        'Semifabricate (Reteta)',
        'Produs finit (Reteta)',
        'Produs rezidual',
        'Ambalaje',
        'Obiecte de inventar'
      ],
      state: null,
      selectedCategory: null,
      isInEdit: false,
      isBlocked: false,
      locations: [],
      gestiuneOptions: [],
      productsList: [],
      gestiuniList: [],
      inventoryNumberOptions: []
    }
  },
  async created () {
    this.companyID = this.$session.get('selectedCompany')

    let vatNumber = this.route && this.route.params && this.route.params.vatNumber
    let series = this.route && this.route.params && this.route.params.series
    let number = this.route && this.route.params && this.route.params.number
    let externalLocationId = this.route && this.route.params && this.route.params.externalLocationId

    // așteaptă întâi locațiile și gestiunile
    await this.fetchLocation()
    console.log('Locations after fetch:', this.locations)
    await this.fetchGestiuni()
    console.log('Gestiuni after fetch:', this.gestiuneOptions)

    if (vatNumber && series && number) {
      this.isInEdit = true

      // apelează getInventory cu datele deja încărcate
      await this.getInventory(vatNumber, series, number, externalLocationId)
    }
  },
  watch: {
    selectedLocation () {
      if (!this.selectedGestiune && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      if (!this.isInEdit) {
        this.productsList = []
        this.getSeries()
      }
    },
    selectedGestiune () {
      if (!this.isInEdit) {
        this.fetchProducts()
      }
    },
    inventoryDate () {
      if (!this.isInEdit) {
        this.fetchProducts()
      }
    }
  },
  computed: {
    today () {
      const now = new Date()
      now.setSeconds(0, 0)
      return now.toISOString().slice(0, 16)
    },
    validate () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) { this.saveInventar(false) }
      })
    },
    seriesOptionsWithAdd () {
      return [
        ...this.inventoryNumberOptions,
        { _id: 'add', label: '➕ Adaugă serie' }
      ]
    },
    searchResults () {
      return this.productsList.map(item => ({
        ...item,
        label: item.productDetails.name
      }))
    },
    groupedLocations () {
      const groups = {}

      this.locations.forEach(location => {
        const vat = location.inv_fiscal_code || 'Fără cod fiscal'
        if (!groups[vat]) {
          groups[vat] = []
        }
        groups[vat].push(location)
      })

      const result = Object.entries(groups).map(([vat, locations]) => ({
        vat,
        locations
      }))

      // console.log('groupedLocations result:', result)  // afisează rezultatul final

      return result
    },
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  methods: {
    filterProducts () {
      this.productsList.forEach(p => {
        if (!this.selectedCategory || p.productDetails.categorie === this.selectedCategory) {
          p.is_hiden = 0
        } else {
          p.is_hiden = 1
        }
      })
    },
    async updateStockScriptic () {
      const stock = await this.fetchProducts(true)
      if (!stock.length) return

      const stockMap = new Map(
        stock.map(p => [p.product_id, p])
      )

      this.productsList = this.productsList.map(p => {
        const updated = stockMap.get(p.product_id)

        if (updated) {
          const changed = p.quantity !== updated.quantity

          return {
            ...p,
            quantity: updated.quantity,
            _updated: changed
          }
        }

        return p
      })
    },
    onProductSelect (selected) {
      if (selected && selected.productDetails) {
        this.newItem = {
          id: selected.productDetails._id,
          name: selected.productDetails.name,
          quantity: selected.quantity || 0,
          unitMeasure: selected.productDetails.um || '',
          stocFaptic: null
        }
      }
    },
    formatDateTime (value) {
      if (!value) return '-'

      const d = new Date(value)

      return new Intl.DateTimeFormat('ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(d)
    },
    getProductNameById (productId) {
      if (!productId) return ''

      const product = this.productsList.find(p => p.product_id === productId)
      if (product && product.productDetails && product.productDetails.name) {
        return product.productDetails.name
      }

      return productId
    },
    translateSaveError (error) {
      const translations = {
        'Inventory cannot be validated before existing stock movements':
          'Inventarul nu poate fi validat înaintea mișcărilor de stoc existente.'
      }

      return translations[error] || error
    },
    formatSaveError (data, status) {
      const fallback = 'A apărut o problemă la salvare.'
      if (!data || typeof data !== 'object') {
        return status ? `${fallback}<br>Cod: ${status}` : fallback
      }

      const message = this.translateSaveError(data.error || data.message) || fallback
      const details = data.details
      if (!details || typeof details !== 'object') {
        return this.escapeHtml(message)
      }

      const rows = []
      if (details.product_id) {
        rows.push(`<strong>Produs:</strong> ${this.escapeHtml(this.getProductNameById(details.product_id))}`)
      }
      if (details.movement_timestamp) {
        rows.push(`<strong>Data mișcării:</strong> ${this.escapeHtml(this.formatDateTime(details.movement_timestamp))}`)
      }
      if (details.movement_id) {
        rows.push(`<strong>ID mișcare:</strong> ${this.escapeHtml(details.movement_id)}`)
      }

      const extraKeys = Object.keys(details).filter(key =>
        !['product_id', 'movement_timestamp', 'movement_id'].includes(key)
      )
      extraKeys.forEach(key => {
        rows.push(`<strong>${this.escapeHtml(key)}:</strong> ${this.escapeHtml(String(details[key]))}`)
      })

      if (!rows.length) {
        return this.escapeHtml(message)
      }

      return `${this.escapeHtml(message)}<br><br>${rows.join('<br>')}`
    },
    escapeHtml (value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    onPrintInventory () {
      const produse = this.productsList.map(p => ({
        productDetails: {
          name: p.productDetails.name || '',
          um: p.productDetails.um || ''
        },
        quantity: Number((p.quantity || 0).toFixed(4))
      }))

      const gestiuneObj = this.filteredGestiuni.find(
        g => g.id === this.selectedGestiune
      )

      const gestiuneName = gestiuneObj ? (gestiuneObj.name || '') : ''

      const selectedSerie = this.seriesOptionsWithAdd.find(
        s => s._id === this.inventoryNumber
      )

      const serieLabel =
        selectedSerie && selectedSerie.label ? selectedSerie.label : ''

      this.printFisaInventariere(
        produse,
        serieLabel,
        this.inventoryDate,
        gestiuneName
      )
    },
    printFisaInventariere (produse = [], serie = {}, data = '', gestiuneName = '') {
      const html = `
        <html>
          <head>
            <title>Fișa de inventariere</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              h1 {
                text-align: center;
                margin-bottom: 5px;
              }
              .meta {
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
                font-size: 14px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                border: 1px solid #000;
                padding: 8px;
                font-size: 13px;
                text-align: left;
              }
              th {
                background: #f2f2f2;
              }
              .right {
                text-align: right;
              }
            </style>
          </head>
          <body>

            <h1>FIȘĂ DE INVENTARIERE</h1>

            <div class="meta">
              <div><strong>Serie:</strong> ${serie}</div>
              <div><strong>Data:</strong> ${this.formatDateTime(data)}</div>
            </div>

            <div class="meta">
              <div><strong>Gestiune:</strong> ${gestiuneName}</div>
            </div>

            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Denumire produs</th>
                  <th>UM</th>
                  <th>Stoc scriptic</th>
                  <th>Stoc faptic</th>
                </tr>
              </thead>
              <tbody>
                ${produse.map((p, i) => `
                  <tr>
                    <td>${i + 1}</td>
                    <td>${p.productDetails.name || ''}</td>
                    <td>${p.productDetails.um || ''}</td>
                    <td class="right">${p.quantity || 0}</td>
                    <td></td>
                  </tr>
                `).join('')}
              </tbody>
            </table>

          </body>
        </html>
      `

      const win = window.open('', '_blank', 'width=900,height=700')
      win.document.open()
      win.document.write(html)
      win.document.close()
      win.focus()
      win.print()
    },
    handleSerieChange (val) {
      if (val === 'add') {
        this.openSeriesModal()
        this.inventoryNumber = null
      }
    },
    openSeriesModal () {
      this.$modal.show('addSeriesModal')
    },
    async getSeries () {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            externalCompanyId: this.companyID,
            vatNumber: this.selectedLocation.inv_fiscal_code,
            tip: 'inventar'
          })
        })

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }

        const data = await response.json()
        // console.log('Serii primite:', data.series)

        if (Array.isArray(data.series)) {
          this.inventoryNumberOptions = data.series.map((serie) => ({
            _id: serie._id,
            series: serie.series,
            currentNumber: serie.currentNumber,
            label: `${serie.series} (${serie.currentNumber})`
          }))
          this.inventoryNumber = this.inventoryNumberOptions.length > 0 ? this.inventoryNumberOptions[0]._id : ''
        } else {
          console.error('Format invalid pentru series:', data)
        }
      } catch (error) {
        console.error('Error fetching series:', error)
      }
    },
    goBack () {
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
    },
    addItem () {
      if (this.newItem && this.newItem.name && this.newItem.stocFaptic != null) {
        const index = this.productsList.findIndex(
          p => p.productDetails._id === this.newItem.id
        )
        if (index !== -1) {
          this.productsList[index].stocFaptic = this.newItem.stocFaptic
        } else {
          // this.$message.error('Produsul nu a fost găsit în listă.')
        }
        this.resetNewItem()
      } else {
        // this.$message.error('Toate câmpurile sunt necesare.')
      }
      return false
    },
    removeItem (index) {
      // this.items.splice(index, 1)
    },
    resetNewItem () {
      this.searchProdName = null
      this.newItem = {
        productName: '',
        code: '',
        unitMeasure: '',
        stocScriptic: null,
        stocFaptic: null
      }
    },
    async fetchLocation () {
      const dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token')
      }

      return new Promise((resolve, reject) => {
        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              icon: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            reject(new Error(response.message || 'Eroare la preluarea locațiilor'))
            return
          }

          this.locations = response.data.locations
          resolve(this.locations)
        })
      })
    },
    async fetchGestiuni () {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
        if (!response.ok) throw new Error('Failed to fetch gestiuni')

        const data = await response.json()
        if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
          this.gestiuneOptions = data.gestiuni.map((gest) => ({
            id: gest._id,
            name: `${gest.name} (${gest.cod_gestiune})`,
            externalLocationId: gest.externalLocationId || ''
          }))
        } else {
          this.$message.error('Nu s-a primit un array valid de la server.')
        }
      } catch (error) {
        this.$message.error(`Request failed: ${error.message}`)
        console.error('Error fetching management data:', error)
      }
    },
    async fetchProducts (refresh = false) {
      if (!this.selectedLocation) {
        return []
      }

      if (!refresh) {
        this.productsList = []
      }

      if (refresh) {
        swal({
          title: 'Se actualizează stocul scriptic...',
          text: 'Vă rugăm așteaptati până se actualizează stocul scriptic cu valorile curente din gestiune',
          allowOutsideClick: false,
          didOpen: () => {
            swal.showLoading()
          }
        })
      }

      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = setTimeout(() => {
        this.loading = true
      }, 10)

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/stock?externalCompanyId=${this.companyID}&gestiune=${this.selectedGestiune}&externalLocationId=${this.selectedLocation.true_id}&date=${this.inventoryDate}`)
        const data = await response.json()

        if (!Array.isArray(data.stock)) {
          this.$message.error('Eroare la încărcarea produselor.')
          return []
        }

        if (!refresh) {
          this.productsList = data.stock
        }

        clearTimeout(this.loadingTimeout)
        this.loading = false
        swal.close()

        return data.stock
      } catch (error) {
        this.$message.error(`Eroare: ${error.message}`)
        clearTimeout(this.loadingTimeout)
        this.loading = false
        swal.close()
        return []
      }
    },
    async getInventory (vatNumber, series, number, externalLocationId) {
      this.loading = true

      swal({
        title: 'Se încarcă...',
        text: 'Așteaptă încărcarea datelor',
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        }
      })

      try {
        const url = new URL(`${process.env.API_BASE_URL_GESTIUNE}:4443/inventar`)
        url.searchParams.append('externalCompanyId', this.companyID)
        url.searchParams.append('vatNumber', vatNumber)
        url.searchParams.append('series', series)
        url.searchParams.append('number', number)
        if (externalLocationId) {
          url.searchParams.append('externalLocationId', externalLocationId)
        }

        const response = await fetch(url.toString())

        if (!response.ok) throw new Error('Eroare la preluarea inventarului')

        const data = await response.json()

        const locationId = externalLocationId || data.externalLocationId

        // setează locația
        this.selectedLocation = this.locations.find(loc =>
          loc.inv_fiscal_code === vatNumber &&
          (!locationId || String(loc.true_id) === String(locationId))
        )

        this.inventoryNumberOptions = [{
          series: data.series,
          currentNumber: data.number,
          label: `${data.series} (${data.number})`,
          _id: `${data.series}-${data.number}`
        }]
        this.inventoryNumber = this.inventoryNumberOptions[0]._id

        this.extraFields = Array.isArray(data.extraFields)
          ? data.extraFields.reduce((acc, { key, value }) => {
            acc[key] = value
            return acc
          }, {})
          : {}
        this.inventoryDate = data.date

        const foundGestiune = this.gestiuneOptions.find(g =>
          g.id === data.gestiune &&
          this.selectedLocation &&
          g.externalLocationId === this.selectedLocation.true_id
        )

        this.selectedGestiune = foundGestiune
          ? foundGestiune.id
          : (this.gestiuneOptions.length > 0 ? this.gestiuneOptions[0].id : null)

        this.state = data.state
        if (data.state === 'VALIDATED') {
          this.isBlocked = true
        }

        // 1. Ia produsele din stoc pentru contextul curent
        await this.fetchProducts()

        // 2. Creează un map din items (cele salvate în inventar)
        const itemsMap = new Map(
          data.items.map(item => [item.product_id, item])
        )

        // 3. Integrează valorile în lista de produse din stoc
        this.productsList = this.productsList.map(p => {
          const saved = itemsMap.get(p.product_id)
          if (saved) {
            return {
              ...p,
              quantity: saved.quantity_scriptic || 0,   // cant scriptic
              stocFaptic: (saved.quantity !== undefined && saved.quantity !== null)
                ? saved.quantity
                : null
            }
          }
          return p
        })
      } catch (error) {
        console.error(error)
        // this.$message.error('Nu s-a putut încărca inventarul.')
      } finally {
        this.loading = false
        swal.close()
      }
    },
    async saveInventar (andValidate) {
      let series = ''
      let number = ''
      const match = this.inventoryNumberOptions.find(opt => opt._id === this.inventoryNumber)
      if (match) {
        series = match.series
        number = match.currentNumber
      }

      const extraFieldsArray = Object.entries(this.extraFields).map(([key, value]) => ({
        key,
        value
      }))

      let items = this.productsList
      .map(p => ({
        product_name: p.productDetails.name,
        product_um: p.productDetails.um,
        quantity_scriptic: p.quantity,
        product_id: p.product_id,
        quantity: (p.stocFaptic !== undefined && p.stocFaptic !== null)
        ? Number(p.stocFaptic)
        : null,
        value: p.value || 0
      }))
      .filter(item => item.quantity !== null)

      if (!items.length) {
        swal({
          title: 'Eroare',
          text: 'Trebuie să completezi cel puțin un produs cu valoare la stoc faptic.',
          type: 'warning'
        })
        return
      }

      const confirmed = await swal({
        icon: 'warning',
        title: 'Atenție!',
        text: 'Vă rog să vă asigurați că unitățile de măsură selectate sunt corecte și că prețul este corespunzător unității de măsură selectate. În cazul în care sunt corecte, continuați apăsând butonul „Salvează”.',
        showCancelButton: true,
        confirmButtonText: 'Salvează',
        cancelButtonText: 'Anulează'
      }).then(result => !!result).catch(() => false)

      if (!confirmed) return

      let status = 'DRAFT'
      if (andValidate) {
        status = 'VALIDATED'
      }

      this.isBlocked = true
      this.loading = true

      swal({
        title: 'Se salvează...',
        text: 'Te rog așteaptă până se finalizează salvarea',
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        }
      })

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/inventar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            externalCompanyId: this.companyID,
            vatNumber: this.selectedLocation.inv_fiscal_code,
            externalLocationId: this.selectedLocation.true_id,
            series: series,
            number: number,
            date: this.inventoryDate,
            gestiune: this.selectedGestiune,
            state: status,
            extraFields: extraFieldsArray,
            items: items
          })
        })

        const data = await response.json().catch(() => null)

        if (!response.ok) {
          swal({
            title: 'Eroare',
            html: this.formatSaveError(data, response.status),
            type: 'error'
          })
          return
        }

        swal({
          title: 'Success',
          text: 'Inventar salvat cu succes.',
          type: 'success',
          timer: 2000,
          showConfirmButton: false
        })

        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      } catch (error) {
        console.error('Error saving inventory:', error)

        swal({
          title: 'Eroare',
          html: this.formatSaveError(error && error.payload, error && error.status),
          type: 'error'
        })
      } finally {
        this.isBlocked = false
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
  .loadingTableCenter {
    height: 100px;
  }
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.btn-primary {
  padding: 5px 50px;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.el-select,
.el-input {
  width: 100%;
}
label {
    display: block;
}
.note-draft {
  margin-bottom: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: white;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}
.save-draft {
  background: transparent;
  border-color: #17B086;
}
.table tbody > tr:hover {
  background-color: #F4F6FF;
}
.row-updated {
  background-color: #fff3cd !important; /* galben soft */
  transition: background 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Inventory/ManagementInventoryForm.vue